import { jsx as _jsx } from "react/jsx-runtime";
import { List, Switch } from 'antd';
import { getFormatMessage } from './index';
import { renderLayoutSettingItem } from './LayoutChange';

var RegionalSetting = function RegionalSetting(_ref) {
  var _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      changeSetting = _ref.changeSetting,
      hashId = _ref.hashId;
  var formatMessage = getFormatMessage();
  var regionalSetting = ['header', 'footer', 'menu', 'menuHeader'];
  return _jsx(List, {
    split: false,
    renderItem: renderLayoutSettingItem,
    dataSource: regionalSetting.map(function (key) {
      return {
        title: formatMessage({
          id: "app.setting.regionalsettings.".concat(key)
        }),
        action: _jsx(Switch, {
          size: "small",
          className: "regional-".concat(key, " ").concat(hashId),
          checked: settings["".concat(key, "Render")] || settings["".concat(key, "Render")] === undefined,
          onChange: function onChange(checked) {
            return changeSetting("".concat(key, "Render"), checked === true ? undefined : false);
          }
        })
      };
    })
  });
};

export { RegionalSetting };